import store from '../store';
import Vue from 'vue';

export default async (to, from, next) => {
    if (!store.getters['auth/check'] && store.getters['auth/token']) {
        try {
            await store.dispatch('auth/getUser')

            // This for when opening the app with logged_in status. 
            if (to.meta.autoMatch) {
                const user = store.getters['auth/user'];

                if (user.hasRoles(['admin', 'reception', 'finance'])) {
                    return next('/');
                } else if (user.hasRoles(['doctor'])) {
                    return next('/doctor/appointments')
                } else {
                    return next('/' + user.roles[0]);
                }
            }

        } catch (e) {
            return Vue.prototype.$snackbar.error(e);
        }
    }
    next()
}